import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddPersonExistingComponent } from '../add-person-existing/add-person-existing.component';
import { confirm, alert } from 'devextreme/ui/dialog';
import { Family, Photo } from 'app/core/model/entity-model';
import _ from 'lodash';
import { BaseDetailComponent } from 'app/shared/shared.module';
import { environment } from 'environments/environment';
import { AppInformationService } from 'app/core/core.module';
import { Subject } from 'rxjs';
import { DevExtremeModule } from 'devextreme-angular';

export interface IPhotoItem {
    photo: Photo;
    url: string;
}
@Component({
    selector: 'app-families-detail',
    templateUrl: './families-detail.component.html',
    styleUrls: ['./families-detail.component.scss'],
    imports: [CommonModule, DevExtremeModule]
})
export class FamiliesDetailComponent extends BaseDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    family: Family;
    key: string;
    members: any[];
    familyRelationships: any;
    states: any[];
    familyStatuses: any;
    households: any;
    canPrintStatement = false;
    photoUrl: string;
    serviceName = environment.serviceName;
    showAsDialog = false;

    closeRelativeUrl = '/people/families/';
    photos: IPhotoItem[];
    selectedPhoto: IPhotoItem;
    uploadHeaders: any;

    async ngOnInit() {
        this.uploadHeaders = { Authorization: 'Bearer ' + this.auth.currentUser.jwtToken };
        const relationships = this.uow.lookups.relationships;
        const peopleStatuses = this.uow.lookups.peopleStatuses;
        this.familyStatuses = this.uow.lookups.familyStatuses;
        this.households = await this.uow.getHouseholds();
        this.states = await this.uow.getStates();
        this.canPrintStatement =
            (this.auth.hasRole('Administrator') || this.auth.hasRole('Treasurer') || this.auth.hasRole('Deacon')) &&
            this.appInfo.graafschap;

        if (this.showAsDialog) {
            this.appInfo.pleaseWaitShow();
        } else {
            this.key = this.route.snapshot.params['id'];
        }

        if (this.key !== 'new') {
            await this.getFamily();
            if (!this.family) {
                await alert('Invalid family id', 'Error');
                // this.location.back();
                // this.router.navigate(['../'], { relativeTo: this.route});
            } else this.family.updateName();
        } else {
            this.family = this.uow.families.createEntity();
            this.family.created = new Date(Date.now());
            this.family.includeInDirectory = true;
            this.family.isActive = true;
            this.family.familyStatusId = 293;

            if (this.appInfo.graafschap) {
                this.family.city = 'Holland';
                this.family.state = 'MI';
                this.family.zip = '49423';
                this.family.country = 'USA';
                this.family.phone = '(616) ';
            }
        }
        this.entity = this.family;
        this.appInfo.pleaseWaitHide();
    }

    private async getFamily() {
        this.family = await this.uow.families.byId(this.key, 'members');
        if (!this.family) return;

        await this.getPhotos();
    }

    private async getPhotos() {
        const photos = await this.uow.photos.where('familyId', '==', this.family.id);
        this.photos = photos.map((photo: any) => {
            return { photo, url: this.utility.getPhoto(photo.fileName) };
            // return { photo, url: `https://peccerium.blob.core.windows.net/graafschap/MemberPhotos/${encodeURIComponent(photo.fileName)}?width=300` };
        });
        const photo: any = _(this.photos).find((p) => p.photo.isDirectoryPhoto);
        if (photo) this.photoUrl = photo.url;
        console.log(this.photos);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    // close() {
    //     try {
    //         this.location.back();
    //     } catch {
    //         this.router.navigate(['/people/families/']);
    //     }
    // }

    async beforeSave() {
        const result = this.validate();
        if (result) this.family.updateName();
        return Promise.resolve(result);
    }

    async afterSave() {
        this.navigateOnSaveNew(this.family.id.toString());
    }


    async close() {
        if (this.showAsDialog) this.closeDialog();
        else {
            const result = await super.close();
            return result;
        }
    }

    async cancel() {
        if (this.showAsDialog) {
            this.closeDialog();
            return null;
        }
        else {
            const result = await super.cancel();
            if (result) await this.getPhotos();
            return result;
        }
    }

    closeDialog() {
        if (this.showAsDialog) this.result.next({ success: false });
    }

    addExisting() {
        const modalRef = this.modalService.show(AddPersonExistingComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                routerOption: 'open',
                familyId: this.family.id,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result) {
                // await this.uow.commit();
            } else this.uow.rollback();
        });
    }

    open(personId?) {
        this.router.navigate(['/people/' + (personId ? personId : 'new')], { queryParams: { familyId: this.key } });
    }

    async delete(personId: number) {
        const result = await confirm('Are you sure you want to remove this person from this family?', 'Remove Person?');
        if (!result) return;

        const person = (await this.uow.people.byId(personId)) as any;
        person.familyId = null;
    }

    photoUploaded() {
        this.getPhotos();
    }

    selectPhoto(photoItem: IPhotoItem) {
        if (this.selectedPhoto && photoItem.photo.id === this.selectedPhoto.photo.id) {
            this.selectedPhoto = null;
        } else this.selectedPhoto = photoItem;
    }

    setDirectoryPhoto() {
        this.photos.forEach((p) => (p.photo.isDirectoryPhoto = false));
        this.selectedPhoto.photo.isDirectoryPhoto = true;
        this.photoUrl = this.selectedPhoto.url;
    }

    async deletePhoto() {
        const result = await confirm('Are you sure you want to delete this photo?', 'Delete Photo?');
        if (!result) return;

        const index = this.photos.findIndex((p) => p.photo.id === this.selectedPhoto.photo.id);
        if (index >= 0) this.photos.splice(index, 1);
        this.selectedPhoto.photo.entityAspect.setDeleted();
        this.selectedPhoto = null;
    }

    async deleteFamily() {
        const result = await confirm('Are you sure you want to delete this family?', 'Delete Family?');
        if (!result) return;

        this.family.entityAspect.setDeleted();
        await this.save();
        this.close();
    }

    async rotateImage(degrees: number) {
        this.appInfo.pleaseWaitShow();
        const picture = this.selectedPhoto.photo as any;
        const result: any = await this.utility.rotateImage(picture.id, degrees);
        if (result.success) {
            picture.url = result.newFilePath;
            picture.thumbnailUrl = this.getThumbnailUrl(picture);
        }
        await this.getPhotos();
        this.appInfo.pleaseWaitHide();
    }

    get selectedPictures() {
        return (this.photos && _(this.photos).filter('selected').value()) || [];
    }

    getThumbnailUrl(picture: any): any {
        return `${AppInformationService.imageProcessorUrl}/${picture.url.substring(8)}` + '?width=200&mode=max&autorotate=true';
    }
}
